import common from './common.json';
import createBooking from './create-booking.json';

export default {
  common,
  createBooking,
};
